var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "singleDisbursementModal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("payment_links.edit_link"),
            "close-on-click-modal": false,
            width: "910px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticClass: "section-title" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("payment_links.payment_link_details")) + " "
            ),
          ]),
          _c("div", { staticClass: "section-tip" }, [
            _vm._v(" " + _vm._s(_vm.$t("payment_links.tip_1")) + " "),
          ]),
          _c(
            "div",
            { staticClass: "form-container" },
            [
              _c(
                "el-form",
                {
                  ref: "singlePaymentForm",
                  attrs: {
                    model: _vm.singlePaymentForm,
                    "status-icon": "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("customerService.payment_method"),
                                prop: "payment_type",
                                rules: [
                                  {
                                    required: true,
                                    message: "Repayment Type cannot be empty",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-item",
                                  attrs: { clearable: "" },
                                  model: {
                                    value: _vm.singlePaymentForm.payment_type,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singlePaymentForm,
                                        "payment_type",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "singlePaymentForm.payment_type",
                                  },
                                },
                                _vm._l(
                                  _vm.repaymentTypeArr,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "customerService.payment_channel"
                                ),
                                prop: "channel_code",
                                rules: [
                                  {
                                    required: true,
                                    message: "Channel Code cannot be empty",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "select-item",
                                  attrs: { clearable: "" },
                                  model: {
                                    value: _vm.singlePaymentForm.channel_code,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.singlePaymentForm,
                                        "channel_code",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "singlePaymentForm.channel_code",
                                  },
                                },
                                _vm._l(
                                  _vm.channelTypeList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.channel_code,
                                        value: item.channel_code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("components.amount"),
                                prop: "amount",
                                rules: [
                                  {
                                    required: _vm.isHasAmount,
                                    message: "Amount cannot be empty",
                                    trigger: "blur",
                                  },
                                  {
                                    validator: _vm.checkAmount,
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-item",
                                attrs: {
                                  type: "text",
                                  placeholder: "Enter amount",
                                  autocomplete: "off",
                                },
                                model: {
                                  value: _vm.singlePaymentForm.amount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singlePaymentForm,
                                      "amount",
                                      $$v
                                    )
                                  },
                                  expression: "singlePaymentForm.amount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("customerService.customer_name"),
                                prop: "customer_name",
                                rules: [
                                  {
                                    required:
                                      _vm.singlePaymentForm.payment_type ===
                                      "Bill Payment",
                                    message: "Customer Name cannot be empty",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  placeholder: "Enter customer name",
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.singlePaymentForm.customer_name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singlePaymentForm,
                                      "customer_name",
                                      $$v
                                    )
                                  },
                                  expression: "singlePaymentForm.customer_name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("customerService.email_address"),
                                prop: "email",
                                rules: [
                                  {
                                    required:
                                      _vm.singlePaymentForm.payment_type ===
                                      "Bill Payment",
                                    message: "Email cannot be empty",
                                    trigger: "blur",
                                  },
                                  {
                                    type: "email",
                                    message: "Please input the correct email",
                                    trigger: ["blur", "change"],
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  placeholder: "Enter email address",
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.singlePaymentForm.email,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singlePaymentForm,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "singlePaymentForm.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 11, offset: 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "email_description",
                                rules: [
                                  {
                                    required: _vm.singlePaymentForm.email,
                                    message:
                                      "Email Description cannot be empty",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("customerService.email_content")
                                      )
                                    ),
                                  ]),
                                  _c(
                                    "el-tooltip",
                                    { attrs: { placement: "top" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("tips.email_content")
                                                )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("br"),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        [
                                          _c("svg-icon", {
                                            staticClass: "icon-question",
                                            attrs: {
                                              "class-name": "icon-question",
                                              "icon-class":
                                                "icon-blue-question",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("el-input", {
                                staticClass: "search-frame",
                                attrs: {
                                  placeholder: "Enter your message",
                                  autocomplete: "off",
                                  clearable: "",
                                },
                                model: {
                                  value:
                                    _vm.singlePaymentForm.email_description,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singlePaymentForm,
                                      "email_description",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "singlePaymentForm.email_description",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("data.remark") } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autocomplete: "off",
                                  placeholder: "Enter your message here",
                                },
                                model: {
                                  value: _vm.singlePaymentForm.remark,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.singlePaymentForm,
                                      "remark",
                                      $$v
                                    )
                                  },
                                  expression: "singlePaymentForm.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-submit",
                  attrs: { type: "info", disabled: _vm.submiting },
                  on: { click: _vm.onClickSubmitBtn },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }